import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import { persistStore } from 'redux-persist';
import thunk from 'redux-thunk';

import { XHRMiddleware } from '../../lib/PST.Web.Common/src/services/api/xhrMiddleware';
import { AuthenticationMiddleware } from '../../lib/PST.Web.Common/src/services/authentication/base';
import { initialState } from './initialState';
import { ApplicationReducer } from './reducer';
import { ProfileMiddleware } from '../profile/profileMiddleware';
import { QuizMiddleware } from '../quiz/quizMiddleware';

const composeEnhancers = composeWithDevTools({
    name: 'pst-frontoffice',
});

const middlewares = [thunk, AuthenticationMiddleware, ProfileMiddleware, QuizMiddleware, XHRMiddleware];

if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'dev') {
    /* eslint-disable global-require */
    const { createLogger } = require('redux-logger');
    /* eslint-enable global-require */
    const logger = createLogger();

    middlewares.push(logger);
}

const enhancer = composeEnhancers(applyMiddleware(...middlewares));

const store = createStore(ApplicationReducer, initialState, enhancer);

const persistor = persistStore(store);

export { store, persistor };
